export default "__VITE_ASSET__a6e7e60d__"